import { createBrowserRouter } from "react-router-dom";
import Home from "./views/home/home";
import Forecast from "./views/forecast/forecast";
import Dishes from "./views/menuEngineering/dishes/dishes";
import MenuEngineering from "./views/menuEngineering/menuEngineering";
import Menus from "./views/menuEngineering/menus/menus";
import Recipes from "./views/menuEngineering/recipes/recipes";
import BaseLayout from "./components/baseLayout/baseLayout";
import SalesMixAnalysis from "./views/salesMix/salesMixAnalysis";
import { SalesMixProvider } from "./context/salesMixContext";
import { ForecastProvider } from "./context/forecastContext";
import PrivateRoute from "./components/PrivateRoute";
import SigninOidc from "./views/login/signinOidc";
import Login from "./views/login/login";

const router = createBrowserRouter([
  {
    path: "/signin-oidc",
    element: <SigninOidc />,
  },
  {
    path: "/login",
    element:<Login />
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
          <BaseLayout />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "sales-mix-analysis",
        children: [
          {
            index: true,
            element: (
              <SalesMixProvider>
                <SalesMixAnalysis />
              </SalesMixProvider>
            ),
          },
        ],
      },
      {
        path: "forecasting",
        element: (
          <ForecastProvider>
            <Forecast />
          </ForecastProvider>
        ),
      },
      {
        path: "menu-engineering",
        element: <MenuEngineering />,
        children: [
          { path: "menus", element: <Menus /> },
          { path: "dishes", element: <Dishes /> },
          { path: "recipes", element: <Recipes /> },
        ],
      },
    ],
  },
]);

export default router;
